<ng-template [vbCssRules]="themeStyleOverrides"></ng-template>

<vb-ui-toggle-content-display [minItems]="4" [totalItems]="supplementalContents.length">
	<div *ngFor="let content of supplementalContents" #vbUiToggleItem>
		<a [ngClass]="styles.item" layout="row" [href]="content.downloadUrl" download [disabled]="!content.downloadUrl" [attr.aria-label]="content.title">
			<span [hidden]="!content.downloadUrl" class="glyphicons" [ngClass]="[styles.fileIcon, getFileExtensionClass(content.extension)]"></span>
			<vb-loading-spinner [hidden]="content.downloadUrl"></vb-loading-spinner>
			<span [ngClass]="styles.fileName">{{content.title}}</span>
		</a>
	</div>
</vb-ui-toggle-content-display>
